import { JsxRenderer } from '@telia-common-components/shared';
import React from 'react';
import RequestFasterInternetModalButton from './RequestFasterInternetModalButton';
const InternetJsxRenderer = (props) => {
    return React.createElement(JsxRenderer, { ...props, webComponents: { RequestFasterInternetModalButton } });
};
export default InternetJsxRenderer;
